export const ExperienceList = [
    {
        company: "Google Developer Student Club",
        position: "Project Head Web",
        timeline: "July 2023 - July 2024",
        companyImage: "GDSC-image.png",
        companyLink: "https://gdsc.community.dev/mgms-college-of-engineering-and-technology-navi-mumbai//",
        description: `Directed and inspired the DSC’23 MGMCET web development team to deliver impactful projects and
        enhance student developer engagement through workshops. 
        Led a team of 6 members through 3 web-based projects, enhancing collaboration, reach, and social impact. Presented technology seminars to over 100 students, fostering comprehensive understanding.`,
        skills: ['Leadership', 'Team Managment', 'Frontend', 'Backend', 'Teamwork', 'Code Review'],
    },
    {
        company: "Freelance",
        position: "Web Developer",
        timeline: "July 2023 - Present",
        companyImage: "freelance.png",
        companyLink: "",
        description: `Developed projects for over 12 clients utilizing React, Node.js, Spring Boot, Swing Toolkit, Tkinter,
        and Python OpenCV.
        Collaborated with clients to gather requirements, plan projects, and ensure successful delivery within agreed timelines and budgets.`,
        skills: ['ReactJS', 'NodeJS', 'SpringBoot', 'Communication', 'Quality', 'Requirement Analysis'],
    },
]